import React from 'react';

interface Props {
  color: string;
}

export const FailICON = (props: Props) => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g stroke={props.color} strokeWidth="1.5" fill="none" fillRule="evenodd">
        <circle cx="14" cy="14" r="13.25" />
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M8.75 8.75l10.5 10.5M19.25 8.75l-10.5 10.5"
        />
      </g>
    </svg>
  );
};

export const SuccessICON = (props: Props) => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        stroke={props.color}
        strokeWidth="1.5"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M22.776 4.073A13.2 13.2 0 0 0 14 .75C6.682.75.75 6.682.75 14S6.682 27.25 14 27.25 27.25 21.318 27.25 14c0-.284-.009-.566-.027-.845" />
        <path d="M7 12.5l7 7 13-13" />
      </g>
    </svg>
  );
};

export const WarningICON = (props: Props) => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="none" fillRule="evenodd">
        <circle
          stroke={props.color}
          strokeWidth="1.5"
          cx="14"
          cy="14"
          r="13.25"
        />
        <path
          stroke={props.color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M14 7.5V15"
        />
        <circle fill={props.color} cx="14" cy="20" r="1" />
      </g>
    </svg>
  );
};

export const WarningFetchICON = (props: Props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h24v24H0z" />
        <circle
          stroke={props.color}
          strokeWidth="1.286"
          cx="12"
          cy="12"
          r="11.357"
        />
        <path
          stroke={props.color}
          strokeWidth="1.286"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M12 6.429v6.428"
        />
        <circle fill={props.color} cx="12" cy="17.143" r="1" />
      </g>
    </svg>
  );
};
